//#region src/components/Tree/helpers/selectionProcessing.ts
var e = (e) => {
	let t = /* @__PURE__ */ new Set(), n = (e) => {
		if (!e.children?.length || !e.collapsible) {
			t.add(e.id);
			return;
		}
		e.children.forEach(n);
	};
	return e.forEach(n), Array.from(t);
}, t = (e) => !!e.children?.length;
//#endregion
export { e as getLeafNodeIds, t as hasChildren };
